import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { TextField } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';

import "./TimePicker.scss";

const TimePicker = ({ label, timeSlot, onChange, className }) => {

  const [value, setValue] = useState(null);

  useEffect(() => {
    if (timeSlot) {
      const formattedValue = dayjs(timeSlot, "HH:mm");
      setValue(formattedValue);
    }
  }, [timeSlot]);

  const handleChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const formattedTime = new Date(newValue?.$d)?.toLocaleTimeString('en-GB');
      setValue(newValue);
      console.log("formattedTime",formattedTime)
      onChange(formattedTime);
    }
  };

    return (
      <div className="time-picker-wrapper"> 
      <LocalizationProvider dateAdapter={AdapterDayjs}> 
        <DesktopTimePicker
            label={label}
            className={className}
            value={value || timeSlot}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      </div>
    );
};

export default TimePicker;

TimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  timeSlot: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};